module.exports = __webpack_public_path__ + "public/img/img-mobile-prakerja-3.39b17e25.png";